import {
  anAddInsightComment,
  anInsightComment,
  mockAddInsightCommentOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const addInsightCommentResponse = (
  comment: string = 'test comment'
) => ({
  __typename: 'Mutation' as const,
  addInsightComment: anAddInsightComment({
    data: {
      ...anInsightComment({
        id: '1',
        body: comment,
      }),
    },
  }),
});

export const handlers = [
  mockAddInsightCommentOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(150);
      return HttpResponse.json({
        data: addInsightCommentResponse(),
      });
    }
  ),
];
